import { Layout } from 'antd';

const { Footer } = Layout;

const FooterNav = () => <Footer />;

export default FooterNav;
